import { h, Component } from 'preact';
import cn from 'classnames';
import styles from './textBox.css';

export const propsToRemove = ['setValidations', 'resetValue', 'hasValue',
  'getErrorMessage', 'getErrorMessages', 'isFormDisabled', 'isValid', 'isPristine',
  'isFormSubmitted', 'isRequired', 'showRequired', 'showError', 'isValidValue',
  'validationError', 'validationErrors', 'onChange', 'containerClassName'];

export default class TextBox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasContent: !!((props.value && props.value.length)
        || (props.defaultValue && props.defaultValue.length))
    };
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      hasContent: nextProps.value && nextProps.value.length
    });
  }

  changeHandler = (event) => {
    const { onChange } = this.props;
    this.setState({
      hasContent: !!event.target.value.length
    });

    if (onChange) {
      onChange(event);
    }
  }

  render() {
    const { className, containerClassName, label,  disabled, multiline } = this.props;
    const inputProps = Object.assign({}, this.props, {
      className: cn('handDrawn', className, styles.input, {
        [styles.inputFilled]: this.state.hasContent,
        [styles.disabled]: disabled
      })
    });
    const labelClasses = cn(styles.label);
    const containerClasses = cn(styles.container, containerClassName);
    const Cmp = multiline ? 'textarea' :  'input';

    // Remove any of our custom props that shouldn't be passed down to <input />
    propsToRemove.forEach(key => delete inputProps[key]);

    return (<span className={containerClasses}>
      <label className={labelClasses}>
        <span className={styles.labelContent}>
          <span>{label}</span>
        </span>
      </label>
      <Cmp {...inputProps} onInput={this.changeHandler} />
    </span>);
  }
}



// WEBPACK FOOTER //
// ./components/textBox/textBox.jsx